import * as Sentry from "@sentry/react";

const { host } = location;

Sentry.init({
  dsn:
    host === "app.getsimio.com" &&
    "https://6d8a3d6cd1b5768f6675afc4ac64aa31@sentry.prod.alcmeon.net/73",
  environment: "production",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
  tracesSampleRate: 0.1,
  profilesSampleRate: 0.1,
  beforeSend(event) {
    if (
      event.message?.includes &&
      event.message.includes("Non-critical error")
    ) {
      return null;
    }
    return event;
  },
});

export const setSentryUser = (user) => {
  try {
    if (user) {
      const { id, email, firstName, lastName, customer } = user;
      Sentry.setUser({
        id,
        email,
        firstName,
        lastName,
        customerId: customer?.id,
        customerName: customer?.name,
      });
    } else {
      Sentry.setUser(null);
    }
  } catch {
    console.error(`Unable to set the sentry's user`);
  }
};
